import React from 'react'
import Footer from '../../Layout/Footer'
import Header from '../../Layout/Header'
import Sidebar from '../../Layout/Sidebar'
import Select from 'react-dropdown-select';
import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { downloadPrescreenReport } from "../../../Api/PreScreen";
import { getAllProjectReport, viewProjectReport } from '../../../Api/Report'
import { getSngleProjectReport } from "../../../Api/Project";
import {getGroupProjectReport} from "../../../Api/ProjectGroup"
import { forceDownloadFile } from "../../../ApiService";

function Project_report() {
    useEffect(() => {
        document.title = "Project Report - Mindforce"
    },);
    const [lists, setLists] = useState();
    const [selProjectID, setProjectID] = useState();
    const [type, setType] = useState('project');
    const [startDate, setStartTimestamp] = useState();
    const [endDate, setEndTimestamp] = useState();
    const [projectReportView, setProjectReportView] = useState([]);

    useEffect(() => {
        getReport();
    }, []);

    const getValidationMessage = () => {
        if (!selProjectID) return 'Please select a project';
        if (!startDate || !endDate) return 'Please select start date and end date';
        if (startDate > endDate) return 'End date must be greater than or equal to start date';
        return '';
    }

    const isFormValid = getValidationMessage() === '';

    const showValidationError = () => {
        const message = getValidationMessage() || 'Please select all required fields';
        Swal.fire({
            icon: 'warning',
            text: message,
            timer: 2000,
            showConfirmButton: false
        });
    }

    const getSelectedProjectDetailID = () => {
        const prjIds = selProjectID?.split('-');
        return prjIds?.[1];
    }

    const setTimestamp = (d, t) => {
        if (t === 'startDate')
            setStartTimestamp(d || undefined);
        else if (t === 'endDate')
            setEndTimestamp(d || undefined);
    }

    const downloadReport = async (e) => {
        e.preventDefault();
        if (!isFormValid) {
            showValidationError();
            return;
        }

        const projectDetailID = getSelectedProjectDetailID();
        if(type === 'project'){
            let prjIds = selProjectID?.split('-');
            let res;
            if(prjIds[0] === 'single')
            res = await getSngleProjectReport({ id: projectDetailID, startDate, endDate })
            else
            res = await getGroupProjectReport({ id: projectDetailID, startDate, endDate })
            if (res?.status === 1) {
                await forceDownloadFile(res?.payload?.reportURL);
            }
        }else if(type === 'prescreen'){
            let payload = {
                projectDetailId: projectDetailID,
                startDate,
                endDate
            }
            let res = await downloadPrescreenReport({payload})
            if (res?.status === 1) {
                await forceDownloadFile(res?.payload?.reportURL);
            }
        }
        
    }

    const getViewReport = async (e) => {
        e.preventDefault();
        if (!isFormValid) {
            showValidationError();
            return;
        }

        let res = await viewProjectReport({
            payload: {
                projectDetailID: getSelectedProjectDetailID(),
                startDate,
                endDate
            }
        });
        if (res?.status === 1) {
            setProjectReportView(res.payload || []);
        } else {
            setProjectReportView([]);
        }
    }

    const getReport = async() => {
        let res = await getAllProjectReport();
        if (res.status === 1) {
            let prjList = [];

            res.payload?.map((row) => {
                    prjList.push(
                        {
                            "projectDetailID": row.projectType + '-' + row.projectDetailID,
                            "projectDetailFullName": row.projectDetailCode + ': ' + row.projectDetailFullName + ' - ' + row.countryName,
                        }
                    )
                }
            )
            setLists(prjList);
        } else 
        setLists([]);
    }

    const onTypeChange = (nextType) => {
        setType(nextType);
        setProjectReportView([]);
    }

    return (
        <div>
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-12 col-lg-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <div>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item"><a >Report</a></li>
                                                <li className="breadcrumb-item active">Project Report</li>
                                            </ol>
                                        </div>
                                        <h4 className="mb-sm-0">Project Report</h4>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className="row">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">

                                        {/* <!-- end card header --> */}

                                        <div className="card-body">
                                            <div className="report">
                                                <form >
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="mb-3">
                                                                <label htmlFor="ForminputState" className="form-label mb-0">Project <span className="required_field">*</span></label>
                                                                <Select
                                                                    className="form-control"
                                                                    options={lists}
                                                                    labelField="projectDetailFullName"
                                                                    valueField="projectDetailID"
                                                                    searchBy="projectDetailFullName"
                                                                    onChange={(values) => {
                                                                        setProjectID(values[0]?.projectDetailID);
                                                                        setProjectReportView([]);
                                                                    }}
                                                                    placeholder="Select Project"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="mb-3">
                                                                <label htmlFor="startDate" className="form-label mb-0">Start Date <span className="required_field">*</span></label>
                                                                <input type="date" className="form-control" id="startDate" max={new Date().toISOString().split("T")[0]} onChange={() => setTimestamp(document.getElementById('startDate').value, 'startDate')} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <div className="mb-3">
                                                                <label htmlFor="endDate" className="form-label mb-0">End Date <span className="required_field">*</span></label>
                                                                <input type="date" className="form-control" id="endDate" max={new Date().toISOString().split("T")[0]} onChange={() => setTimestamp(document.getElementById('endDate').value, 'endDate')} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row align-items-center">
                                                        <div className="col-md-6">
                                                            <div className="d-flex flex-wrap gap-4 mb-3">
                                                                <div className="form-check rmPL mb-0">
                                                                    <input className="form-check-input" name="rdoReport" type="radio" id="formCheckProject" checked={type === 'project'} onChange={() => onTypeChange('project')} />
                                                                    <label className="form-check-label" htmlFor="formCheckProject">
                                                                        Project Report <span className="required_field">*</span>
                                                                    </label>
                                                                </div>
                                                                <div className="form-check rmPL mb-0">
                                                                    <input className="form-check-input" name="rdoReport" type="radio" id="formCheckPreScreen" checked={type === 'prescreen'} onChange={() => onTypeChange('prescreen')} />
                                                                    <label className="form-check-label" htmlFor="formCheckPreScreen">
                                                                        PreScreen Report <span className="required_field">*</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="text-end report_btn mb-3">
                                                                {!isFormValid && (
                                                                    <div className="text-danger small mb-2">Please select all required fields</div>
                                                                )}
                                                                <button type="button" className="btn btn-primary" disabled={!isFormValid} onClick={(e) => getViewReport(e)}>View</button>
                                                                <button type="button" className="btn btn-primary mx-2" disabled={!isFormValid} onClick={(e) => downloadReport(e)}>Download</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mt-3'>
                                                        <div className='hScrollDiv'>
                                                            <table className="table table-striped table-hover table_client">
                                                                {projectReportView?.length > 0 ? (
                                                                    <>
                                                                        <thead>
                                                                            <tr className="bg-primary" style={{ color: "white" }}>
                                                                                <th>S.No.</th>
                                                                                <th>Project Code</th>
                                                                                <th style={{ textAlign: "left" }}>Project Name</th>
                                                                                <th style={{ textAlign: "left" }}>Country</th>
                                                                                {type === 'project' ? (
                                                                                    <>
                                                                                        <th>Complete</th>
                                                                                        <th>Terminate</th>
                                                                                        <th>OverQuota</th>
                                                                                        <th>QualityTerm</th>
                                                                                        <th>DropOut</th>
                                                                                        <th>DuplicateUser</th>
                                                                                        <th>DuplicateIP</th>
                                                                                        <th>Speeder</th>
                                                                                        <th>RDFailure</th>
                                                                                        <th>Exclude</th>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <th>PS Start</th>
                                                                                        <th>PS Terminate</th>
                                                                                        <th>PS OverQuota</th>
                                                                                        <th>PS DropOut</th>
                                                                                    </>
                                                                                )}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {projectReportView.map((project, i) => (
                                                                                <tr key={project.projectDetailID || i}>
                                                                                    <td>{i + 1}</td>
                                                                                    <td>{project?.projectDetailCode}</td>
                                                                                    <td style={{ textAlign: "left" }}>{project?.projectDetailFullName}</td>
                                                                                    <td style={{ textAlign: "left" }}>{project?.countryName}</td>
                                                                                    {type === 'project' ? (
                                                                                        <>
                                                                                            <td>{project?.complete}</td>
                                                                                            <td>{project?.terminate}</td>
                                                                                            <td>{project?.overQuota}</td>
                                                                                            <td>{project?.qualityTeam}</td>
                                                                                            <td>{project?.dropOut}</td>
                                                                                            <td>{project?.duplicateUser}</td>
                                                                                            <td>{project?.duplicateIP}</td>
                                                                                            <td>{project?.speeder}</td>
                                                                                            <td>{project?.rdFailure}</td>
                                                                                            <td>{project?.exclude}</td>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <td>{project?.psStart}</td>
                                                                                            <td>{project?.psTerminate}</td>
                                                                                            <td>{project?.psOverQuota}</td>
                                                                                            <td>{project?.psDropOut}</td>
                                                                                        </>
                                                                                    )}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </>
                                                                ) : null}
                                                            </table>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                {/* <!-- end col --> */}








                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Project_report
